import axiosInstance from "../../../helpers/api";

export const getAllStudents = ({ payload }) => {
  return axiosInstance.get(`/superadmin/users/pending?name=${payload?.name}`);
};
export const getAllActiveStudents = ({ payload }) => {
  return axiosInstance.get(`/superadmin/users/active?name=${payload?.name}`);
};

export const approveStudent = (formData) => {
  return axiosInstance.put(`/superadmin/users/${formData.id}/approve`);
};

export const rejectStudent = (formData) => {
  return axiosInstance.post(`/superadmin/users/${formData.id}/reject`);
};

export const addBulkStudent = (formData) => {
  return axiosInstance.post(`/superadmin/users/bulk`, formData);
};

export const createStudents = (formData) => {
  return axiosInstance.post("/superadmin/users", formData);
};

export const editStudents = (formData) => {
  return axiosInstance.post(
    `/superadmin/users/${formData?.id}`,
    formData.formData
  );
};

export const deleteStudent = (id) => {
  return axiosInstance.delete(`/superadmin/users/${id}`);
};

export const resetStudentPassword = (id) => {
  return axiosInstance.post(`/superadmin/users/reset-password/${id}`);
};